const MAX_EDGE = 2000;
const QUALITY = 0.86;
const SKIP_BELOW = 1.5 * 1024 * 1024;

/**
 * Downscale/re-encode a photo in the browser before upload. Falls back to the
 * original file if the browser can't decode it (e.g. HEIC on Chrome) — the
 * server normalises those.
 */
export const compressImage = async (file) => {
  if (!file.type.startsWith("image/") && !/\.(heic|heif)$/i.test(file.name)) return file;
  if (file.size < SKIP_BELOW && !/heic|heif/i.test(file.type + file.name)) return file;
  try {
    const bitmap = await createImageBitmap(file);
    const scale = Math.min(1, MAX_EDGE / Math.max(bitmap.width, bitmap.height));
    const w = Math.round(bitmap.width * scale), h = Math.round(bitmap.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    canvas.getContext("2d").drawImage(bitmap, 0, 0, w, h);
    bitmap.close?.();
    const blob = await new Promise((res) => canvas.toBlob(res, "image/jpeg", QUALITY));
    if (!blob) return file;
    return new File([blob], file.name.replace(/\.[^.]+$/, "") + ".jpg", { type: "image/jpeg" });
  } catch {
    return file;
  }
};
